import {
  FinancialSupportCaseCreateDto,
  FinancialSupportGrantBenefitDto,
} from '@hello-unicorn/api-client';

export type FinancialSupportDraft = {
  industryName: string;
  businessAgeYears: number;
  annualRevenue: number;
  employeeCount: number;
  availableCash: number;
  monthlyEssentialExpense: number;
  purpose: FinancialSupportCaseCreateDto['purpose'] | '';
  requestedAmount: number;
  companyName?: string;
  businessForm?: FinancialSupportCaseCreateDto['businessForm'] | '';
  industryCode?: string;
  taxType?: FinancialSupportCaseCreateDto['taxType'] | '';
  openedAt?: string;
  businessRegion?: string;
  businessDistrict?: string;
  franchise?: boolean;
  occupancy?: FinancialSupportCaseCreateDto['occupancy'] | '';
  normalizedOwnership?: FinancialSupportCaseCreateDto['normalizedOwnership'] | '';
  representativeBirthYear?: number | null;
  representativeGender?: FinancialSupportCaseCreateDto['representativeGender'] | '';
  representativeHomeRegion?: string;
  pastStartupCount?: number | null;
  pastClosureCount?: number | null;
  sameIndustryCareerYears?: number | null;
  revenue2023?: number | null;
  revenue2024?: number | null;
  revenue2025?: number | null;
  revenue2025SamePeriod?: number | null;
  revenue2026Ytd?: number | null;
  operatingProfit2025?: number | null;
  employeeCount2025?: number | null;
  employeeCount2026?: number | null;
  monthlyEssentialExpense2025?: number | null;
  monthlyEssentialExpense2026?: number | null;
  monthlyRent2026?: number | null;
  receivables?: number | null;
  payablesWithin30Days?: number | null;
  taxDue?: boolean;
  insuranceDue?: boolean;
  cbScore?: number | null;
  sohoScore?: number | null;
  loanCount?: number | null;
  monthsSinceLastLoan?: number | null;
  delinquentNow?: boolean;
  currentFinancialBalance?: number | null;
  monthlyRepayment?: number | null;
  financialInstitutionCount?: number | null;
  cumulativeDelinquencyCount?: number | null;
  maxDelinquencyDays?: number | null;
  grantBenefits?: FinancialSupportGrantBenefitDto[];
};

export const createFinancialSupportDraft = (): FinancialSupportDraft => ({
  companyName: '',
  businessForm: '',
  industryName: '',
  industryCode: '',
  taxType: '',
  openedAt: '',
  businessRegion: '',
  businessDistrict: '',
  franchise: false,
  occupancy: '',
  normalizedOwnership: '',
  representativeBirthYear: null,
  representativeGender: '',
  representativeHomeRegion: '',
  pastStartupCount: null,
  pastClosureCount: null,
  sameIndustryCareerYears: null,
  revenue2023: null,
  revenue2024: null,
  revenue2025: null,
  revenue2025SamePeriod: null,
  revenue2026Ytd: null,
  operatingProfit2025: null,
  employeeCount2025: null,
  employeeCount2026: null,
  availableCash: 0,
  monthlyEssentialExpense2025: null,
  monthlyEssentialExpense2026: null,
  monthlyRent2026: null,
  receivables: null,
  payablesWithin30Days: null,
  taxDue: false,
  insuranceDue: false,
  cbScore: null,
  sohoScore: null,
  loanCount: null,
  monthsSinceLastLoan: null,
  delinquentNow: false,
  currentFinancialBalance: null,
  monthlyRepayment: null,
  financialInstitutionCount: null,
  cumulativeDelinquencyCount: null,
  maxDelinquencyDays: null,
  grantBenefits: [],
  businessAgeYears: 0,
  annualRevenue: 0,
  employeeCount: 0,
  monthlyEssentialExpense: 0,
  purpose: '',
  requestedAmount: 0,
});
